import React, { FC } from 'react';
import styles from './Overlay.module.scss';
// import { Mode, Store } from '@/src/app/(root)/find-a-dealer/MapSection/Types/types';
// import Image from 'next/image';
import CloseIcon from '../../../../../assets/icons/close.svg';
import BackArrow from '../../../../../assets/icons/back-arrow.svg';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';
// import { LeadData, submitLead } from '@/src/app/(root)/contact-us/services/leadsService';
// import PhoneInputField from '../../../ui/PhoneInputField/PhoneInputField';
import { Image } from '@sitecore-jss/sitecore-jss-react';

const schema = yup.object().shape({
  uniqueKey: yup.string(),
  extendedField4: yup.string().required('This field is mandatory'),
  firstName: yup.string().required('This field is mandatory'),
  lastName: yup.string().required('This field is mandatory'),
  contactEmail: yup.string().email('Invalid email').required('This field is mandatory'),
  primarySource: yup.number(),
  primaryContactType: yup.number(),
  secondarySource: yup.number(),
  brand: yup.string(),
  countryCode: yup.string(),
  contactTel: yup
    .string()
    .matches(
      /^(\+44\s?7\d{3}|\(?\d{2,5}\)?)\s?\d{3,4}\s?\d{3,4}$/,
      'The phone number must be valid for the UK format'
    )
    .required('This field is mandatory'),
  optout: yup
    .boolean()
    .oneOf([true], 'This field is mandatory')
    .required('This field is mandatory'),
  storeCode: yup.string(),
});

// type ContactSectionProps = {
//   selectedStore: Store;
//   onBack: () => void;
//   onStart: () => void;
//   setMode: React.Dispatch<React.SetStateAction<Mode>>;
// };

// type FormData = yup.InferType<typeof schema>;

const ContactSection = ({ selectedStore, onBack, setMode, onStart }) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const {
    trigger,
    handleSubmit,
    register,
    setValue,
    control,
    formState: { errors },
  } = methods;

  const onSubmit = async (data) => {
    const newId = uuidv4();
    setValue('storeCode', selectedStore.storeCode);
    setValue('uniqueKey', newId);
    setValue('primarySource', 2);
    setValue('secondarySource', 70);
    setValue('brand', 'JAECOO');
    setValue('primaryContactType', 20);
    setValue('countryCode', selectedStore.country.code);
    setMode('THANKS');

    const leadData = {
      input: {
        ...data,
        optout: !data.optout,
      },
      LangId: '1033',
    };

    try {
      await submitLead(leadData);
      setMode('THANKS');
    } catch (error) {}
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.contactSection}>
          <button className={styles.closeButton} onClick={onStart}>
            <Image src={CloseIcon} alt="Close" />
          </button>
          <button className={styles.backButton} onClick={onBack} type="button">
            <Image src={BackArrow} alt="Back" />
          </button>
          <h3 className={styles.contactTitle}>Contact a dealer</h3>
          <p className={styles.dealerAddress}>
            {selectedStore?.address || 'Address not available'}
          </p>

          <div className={styles.contactForm}>
            <div>
              <label className={styles.label}>Request Category</label>
              <select className={styles.select} {...register('extendedField4')}>
                <option value="service">Purchase or test drive</option>
                <option value="other">Service</option>
              </select>
              {errors.extendedField4 && (
                <p className={styles.error}>{errors.extendedField4.message}</p>
              )}
            </div>
            <div>
              <label className={styles.label}>First name</label>
              <input
                className={styles.input}
                type="text"
                placeholder="Enter your first name"
                {...register('firstName')}
                onBlur={() => trigger('firstName')}
              />
              {errors.firstName && <p className={styles.error}>{errors.firstName.message}</p>}
            </div>

            <div>
              <label className={styles.label}>Last name</label>
              <input
                className={styles.input}
                type="text"
                placeholder="Enter your last name"
                {...register('lastName')}
                onBlur={() => trigger('lastName')}
              />
              {errors.lastName && <p className={styles.error}>{errors.lastName.message}</p>}
            </div>
            <div>
              <label className={styles.label}>Email</label>
              <input
                className={styles.input}
                type="email"
                placeholder="Enter your email"
                {...register('contactEmail')}
                onBlur={() => trigger('contactEmail')}
              />
              {errors.contactEmail && <p className={styles.error}>{errors.contactEmail.message}</p>}
            </div>
            <label className={styles.label}>Phone</label>
            <div className={styles.phoneNumberInput}>
              {/* <PhoneInputField control={control} name="contactTel" trigger={trigger} /> */}
              {/* {errors.contactTel && <p className={styles.error}>{errors.contactTel.message}</p>} */}
            </div>
            <div className={styles.checkboxContainer}>
              <label className={styles.checkboxLabel}>
                <input type="checkbox" className={styles.checkboxInput} {...register('optout')} />
                <span className={styles.customCheckbox}></span>I read and accept the{' '}
                <a
                  href={selectedStore?.fields?.privacyUrl?.value?.href || '/privacy-policy'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </label>
              {errors.optout && <p className={styles.error}>{errors.optout.message}</p>}
            </div>
            <div className={styles.buttonContainer}>
              <button className={styles.acceptButton} type="submit">
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default ContactSection;
